const EvaluatorPaymentViewsEnum = {
  AllPaymentRequests: 'All Payment Requests',
  MyOfficePendingApproval: 'My Office Pending Approval',
  MyPaymentRequestsPendingApproval: 'My Payment Requests Pending Approval',
  MyOfficePaymentRequestsPendingApproval: 'My Office Payment Requests Pending Approval',
  PendingApproval: 'Pending Approval',
  PendingReview: 'Pending Review',
  MyOfficePendingReview: 'My Office Pending Review',
  MyPaymentRequests: 'My Payment Requests',
  MyOfficeEmptyPayments: 'My Office Empty Payments',
  MyPaymentRequestsInformationRequired: 'My Payment Requests Information Required',
  AllEmptyPayments: 'All Empty Payments',
  MyOfficePaymentRequests: 'My Office Payment Requests',
  AllPendingApproval: 'All Pending Approval',
  PendingApprovalVAT: 'Pending Approval VAT',
  // CD-5483: the payments pending supervisor approval the signed-in user may approve. Equal to the server's
  // EvaluatorPaymentApprovalConstants.PendingSupervisorApprovalView and to the View in the approval email's links.
  PendingSupervisorApproval: 'Pending Supervisor Approval',
};

export default EvaluatorPaymentViewsEnum;
